<template>
  <div>
    <div class="d-flex justify-end mb-4">
      <v-btn
        outlined
        color="error"
        small
        :loading="isClearing"
        @click="clearCacheAndReload"
      >
        <v-icon
          left
          small
        >
          {{ icons.mdiCached }}
        </v-icon>
        キャッシュを削除して再読み込み
      </v-btn>
    </div>

    <!-- 注文通知設定はタブに依存せず常に表示する -->
    <order-notification-view-card />

    <v-tabs
      v-model="tab"
      class="mb-6"
    >
      <v-tab>レシート</v-tab>
      <v-tab>キッチン</v-tab>
      <!-- 未印刷伝票(PrintTicket)はSDP有効プリンタにのみ生成される。SDP未運用店舗では常に空なのでタブごと非表示 -->
      <v-tab v-if="hasSdpPrinter">
        未印刷伝票の再送
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item eager>
        <receipt-printer-setting-card />
        <device-print-toggle-card />
      </v-tab-item>
      <v-tab-item eager>
        <kitchen-printer-setting-card />
      </v-tab-item>
      <v-tab-item
        v-if="hasSdpPrinter"
        eager
      >
        <print-tickets-card />
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import { ref, defineComponent } from '@vue/composition-api'
import { mdiCached } from '@mdi/js'
import ReceiptPrinterSettingCard from '@/views/components/printer/ReceiptPrinterSettingCard.vue'
import DevicePrintToggleCard from '@/views/components/printer/DevicePrintToggleCard.vue'
import KitchenPrinterSettingCard from '@/views/components/printer/KitchenPrinterSettingCard.vue'
import OrderNotificationViewCard from '@/views/components/printer/OrderNotificationViewCard.vue'
import PrintTicketsCard from '@/views/components/printer/PrintTicketsCard.vue'
import KitchenPrinterApi from '@/api/waiter/KitchenPrinter'

export default defineComponent({
  components: {
    ReceiptPrinterSettingCard,
    DevicePrintToggleCard,
    KitchenPrinterSettingCard,
    OrderNotificationViewCard,
    PrintTicketsCard,
  },
  setup() {
    const tab = ref(0)
    const isClearing = ref(false)

    // SDP有効プリンタが1台でもあるか。無ければ「未印刷伝票の再送」タブを出さない
    // （PrintTicketはSDP有効プリンタにのみ生成されるため、SDP未運用店舗では常に空になる）。
    const hasSdpPrinter = ref(false)
    const checkSdpPrinter = async () => {
      const res = await KitchenPrinterApi.getKitchenPrinterSettings()
      if (res?.status === 200) {
        hasSdpPrinter.value = (res.data.kitchenPrinters?.data || []).some(p => p.attributes?.sdpEnabled)
      }
    }
    checkSdpPrinter()

    // ブラウザ(Service Worker)のキャッシュを削除して最新を読み込む。
    // 古いJS/CSSが残って表示が更新されないときに使う。
    // ログイン情報(localStorage)は保持する。
    const clearCacheAndReload = async () => {
      // eslint-disable-next-line no-alert
      if (!window.confirm('キャッシュを削除して再読み込みします。よろしいですか？（ログイン状態は保持されます）')) return
      isClearing.value = true
      try {
        if ('caches' in window) {
          const keys = await caches.keys()
          await Promise.all(keys.map(key => caches.delete(key)))
        }
        if ('serviceWorker' in navigator) {
          const registrations = await navigator.serviceWorker.getRegistrations()
          await Promise.all(registrations.map(registration => registration.unregister()))
        }
      } finally {
        window.location.reload()
      }
    }

    return {
      tab,
      isClearing,
      hasSdpPrinter,
      clearCacheAndReload,
      icons: { mdiCached },
    }
  },
})
</script>
